// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"ef5a4751","404":"908b0242","481":"58a8e42a","866":"a57da2b6","936":"34fdfe45","964":"d188962e"}[chunkId] + ".chunk.js";
};